import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Box, Stack, Typography, IconButton } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { THEME_TYPE } from '@ui-lib/consts';
import ThemeProvider from '@ui-lib/ThemeProvider';

import { AccessToken } from '@web-shared/services/access-token';
import logo from '../assets/logo-icon.svg';
import { useAuthContext } from '../pages/SplashScreen/AuthContext';

export const Header = () => {
  const { t } = useTranslation();
  
  const ctx = useAuthContext();
  const history = useHistory();

  const isLoggedIn = !!ctx.user;
  const logout = () => {
    ctx.setUser(null);
    AccessToken.clearTokens();
    history.replace('/login');
  };

  return (
    <ThemeProvider themeType={THEME_TYPE.DARK} >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          p: 2,
          backgroundColor: 'neutral.containerLow'
        }}>
        <Box
          component="img"
          src={logo}
          sx={{
            width: 33,
            height: 33,
          }}
        />
        <Stack >
          <Typography variant="body2Bold">
            {t('label_secureBillOfLading')}
          </Typography>
          <Typography variant="caption">
            {t('label_byOverhaul')}
          </Typography>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        {isLoggedIn && (
          <IconButton aria-label="logout" color="secondary" onClick={logout}>
            <LogoutIcon />
          </IconButton>
        )}
      </Stack>
    </ThemeProvider>
  );
};
